import postcss from 'postcss';
import { getElementByXPath } from '@utils/get-element-by-xpath';
import { getElementCSSSelector } from '@utils/get-element-css-selector';
import { queryIframeContent } from '@utils/query';

export const isValidCSS = (cssText) => {
	try {
		// Basic checks for common malicious patterns
		if (!cssText || typeof cssText !== 'string') {
			return false;
		}
		postcss.parse(cssText);
		return true;
	} catch (e) {
		return false;
	}
};

export const isValidHexColor = (str) =>
	/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(str.trim());

export const rgbOrRgbaToHex = (color) => {
	const match = color.match(
		/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/i,
	);
	if (!match) {
		return null;
	} // Not an RGB or RGBA string

	const r = parseInt(match[1]).toString(16).padStart(2, '0');
	const g = parseInt(match[2]).toString(16).padStart(2, '0');
	const b = parseInt(match[3]).toString(16).padStart(2, '0');

	// If alpha present and less than 1, include it
	if (match[4] !== undefined && parseFloat(match[4]) < 1) {
		const a = Math.round(parseFloat(match[4]) * 255)
			.toString(16)
			.padStart(2, '0');
		return `#${r}${g}${b}${a}`.toUpperCase(); // 8-digit hex with alpha
	}

	return `#${r}${g}${b}`.toUpperCase(); // 6-digit hex
};

/**
 * Builds a CSS rule string for color contrast changes.
 */
export const buildCSSRule = (item, data, parents) => {
	const currentParents = data.parents || parents;
	const currentParent =
		currentParents.length > 0 ? currentParents.at(-1) : item.path.dom;

	if (
		(data.color && !isValidHexColor(data.color)) ||
		(data.background && !isValidHexColor(data.background))
	) {
		throw new Error('Invalid hex color input detected');
	}

	try {
		const bgElement = getElementByXPath(currentParent);
		const colorSelector = getElementCSSSelector(item.node);
		const bgSelector = getElementCSSSelector(bgElement);

		const colorRule = data.color
			? `${colorSelector} {color: ${data.color} !important;}`
			: '';

		const bgRule = data.background
			? `${bgSelector} {background-color: ${data.background} !important;}`
			: '';

		const css = `${colorRule}${bgRule}`;

		return isValidCSS(css) ? css : '';
	} catch (e) {
		console.warn('Failed to convert XPath to CSS selector: ', e);
		return '';
	}
};

export const updateCSS = (rule) => {
	const doc = queryIframeContent();

	if (!doc) {
		return;
	}

	let styles = doc.getElementById('ea11y-remediation-styles-edit');

	if (!styles) {
		styles = doc.createElement('style');
		styles.id = 'ea11y-remediation-styles-edit';
		(doc.head || doc.body || doc.documentElement).appendChild(styles);
	}

	styles.innerHTML = rule;
};
